import { useMutation } from '@apollo/client';
import { RecalculateRiskScoresDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';

import { useRecalculateRiskScoresTRPC } from './useRecalculateRiskScoresTRPC';

/**
 * Flag-gated wrapper for recalculateRiskScores (RSP-6156). On the `trpc` flag
 * it routes through the tRPC async-request path; otherwise it falls back to the
 * existing Apollo mutation. The Apollo path is retained until the flag is fully
 * rolled out and the GraphQL action is removed (do NOT hard-switch — see
 * packages/web/CLAUDE.md).
 */
export const useRecalculateRiskScores = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  const [recalculateRiskScoresGraphQL, graphqlState] = useMutation(
    RecalculateRiskScoresDocument
  );

  const trpcMutation = useRecalculateRiskScoresTRPC();

  const recalculateRiskScores = async (): Promise<void> => {
    if (trpcEnabled) {
      await trpcMutation.recalculateRiskScores();

      return;
    }

    await recalculateRiskScoresGraphQL();
  };

  if (trpcEnabled) {
    return {
      recalculateRiskScores,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    recalculateRiskScores,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
